<template>
  <Fragment>
    <div class="row text-white py-3 py-md-4 py-lg-5">
      <div class="col-12 text-center">
        <h2>
          Your Operation could see ROI in
          {{ formatNumber(calc.payback.paybackOnInvestmentFleetMonths) }}
          {{
            calc.payback.paybackOnInvestmentFleetMonths === 1
              ? 'month'
              : 'months'
          }}
        </h2>
      </div>
    </div>
    <div class="row my-2 my-md-4 my-lg-3 pt-3 pt-md-4 roi-chart-container">
      <div class="col-12 col-md-6 text-center mt-3 mt-sm-4">
        <div class="pie-chart grad-dark h-100">
          <div class="flex-grow-1">
            <h3 class="text-white">Annual Savings per Fleet</h3>
          </div>
          <div>
            <SummaryGraph
              :values="fleetSavingsGraphValues"
              label="Annual Savings per Fleet"
            />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 text-center mt-3 mt-sm-4">
        <div class="pie-chart grad-dark h-100">
          <div class="flex-grow-1">
            <h3 class="text-white">Annual Savings per Trailer</h3>
          </div>
          <div>
            <SummaryGraph
              :values="trailerSavingsGraphValues"
              label="Annual Savings per Trailer"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row d-print-none">
      <div class="col-12">
        <div class="form-group row mt-5">
          <div class="col-12 text-center">
            <button
              class="btn btn-primary btn-hend btn-large m-1"
              @click="onGeneratePDF"
            >
              Save PDF
            </button>

            <a
              href="https://micro.hendrickson-intl.com/TMXPRO/index.html"
              type="button"
              class="btn btn-primary btn-hend btn-large m-1"
            >
              Learn More About TIREMAAX<sup>®</sup>
            </a>
            <a
              href="/contact?co=556"
              type="button"
              class="btn btn-primary btn-hend btn-large m-1"
            >
              Sales &amp; Field Contacts
            </a>
          </div>
        </div>
      </div>
    </div>

    <SummaryFooter />
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

import {
  formatNumberAsInteger,
  formatNumber,
} from '@/src/utilities/formatters';

import { mapGetters } from '../../store';

import SummaryFooter from './SummaryFooter.vue';
import SummaryGraph from './SummaryGraph.vue';

export default {
  name: 'Summary',

  components: {
    Fragment,
    SummaryFooter,
    SummaryGraph,
  },

  computed: {
    ...mapGetters(['calculation', 'stepsSet']),

    /** @returns {Calculation} */
    calc() {
      return this.calculation;
    },

    /** @returns {StepsSet} */
    steps() {
      return this.stepsSet;
    },

    /** @returns {ChartDataPoint[]} */
    fleetSavingsGraphValues() {
      return [
        {
          label: 'Fuel',
          value: Math.round(
            this.calc.fleetTotals.annualFuelSavingsFleetDollars,
          ),
          imagePath: this.steps.fuel.imagePath,
          backgroundColor: '#58585a',
        },
        {
          label: 'Maintenance',
          value: Math.round(
            this.calc.fleetTotals.maintenanceSavingsFleetDollars,
          ),
          imagePath: this.steps.maintenance.imagePath,
          backgroundColor: '#a50533',
        },
        {
          label: 'Road Calls',
          value: Math.round(this.calc.fleetTotals.roadCallSavingsFleetDollars),
          imagePath: this.steps.roadCalls.imagePath,
          backgroundColor: '#6e0020',
        },
        {
          label: 'Trailer Tires',
          value: Math.round(this.calc.fleetTotals.tireSavingsForFleetDollars),
          imagePath: this.steps.tires.imagePath,
          backgroundColor: '#002a32',
        },
      ];
    },

    /** @returns {ChartDataPoint[]} */
    trailerSavingsGraphValues() {
      return [
        {
          label: 'Fuel',
          value: Math.round(
            this.calc.trailerTotals.annualFuelSavingsPerTrailerDollars,
          ),
          imagePath: this.steps.fuel.imagePath,
          backgroundColor: '#58585a',
        },
        {
          label: 'Maintenance',
          value: Math.round(
            this.calc.trailerTotals.maintenanceSavingsPerTrailerDollars,
          ),
          imagePath: this.steps.maintenance.imagePath,
          backgroundColor: '#a50533',
        },
        {
          label: 'Road Calls',
          value: Math.round(
            this.calc.trailerTotals.roadCallSavingsPerTrailerDollars,
          ),
          imagePath: this.steps.roadCalls.imagePath,
          backgroundColor: '#6e0020',
        },
        {
          label: 'Trailer Tires',
          value: Math.round(
            this.calc.trailerTotals.tireSavingsPerTrailerDollars,
          ),
          imagePath: this.steps.tires.imagePath,
          backgroundColor: '#002a32',
        },
      ];
    },
  },

  methods: {
    formatNumberAsInteger,
    formatNumber,

    onGeneratePDF() {
      window.print();
    },
  },
};

/**
 * @typedef {import('../../store/state').Calculation} Calculation
 * @typedef {import('../../store/state').StepsSet} StepsSet
 * @typedef {import('./pie-chart').ChartDataPoint} ChartDataPoint
 */
</script>
